import { Box } from 'braid-design-system';

import { LikeButton, CommentButton } from 'src/components/atoms/Buttons';

interface ReactionBarProps {
  likeLabel: string;
  commentLabel: string;
  likeStatus?: boolean;
  onLikeClick?: () => void;
  onCommentClick?: () => void;
}
export default ({
  likeLabel,
  commentLabel,
  likeStatus,
  onLikeClick,
  onCommentClick,
}: ReactionBarProps) => (
  <Box display="flex" justifyContent="flexStart" padding="none">
    <LikeButton
      likeLabel={likeLabel}
      likeStatus={likeStatus}
      onClick={onLikeClick}
    />
    <CommentButton commentLabel={commentLabel} onClick={onCommentClick} />
  </Box>
);
